var isMotionValue = function (value) {
    return Boolean(value !== null && typeof value === "object" && value.getVelocity);
};

export { isMotionValue };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/value/utils/is-motion-value.mjs
// module id = H2MC
// module chunks = 0